import React, { useState, useEffect } from 'react';
import '../styles/mobileMenu.scss';
import logo from '../assets/logo_lockup.svg';
import arrow from '../assets/linkArrow.svg';

function MobileMenu({ showMobileMenu, mobileMenuRef, circleRef, topBarRef, bottomBarRef }) {
  const [scrollingDown, setScrollingDown] = useState(false);
  const linksData = [
    {
      key: 1,
      text: 'the access I',
      url: '#access1'
    },
    {
      key: 2,
      text: 'film',
      url: '#film'
    },
    {
      key: 3,
      text: 'installation',
      url: '#event'
    },
    {
      key: 4,
      text: 'photo gallery',
      url: '#gallery'
    },
    {
      key: 5,
      text: 'interactive',
      url: '#interactive'
    },

    {
      key: 6,
      text: 'the next generation',
      url: '#generation'
    }
  ];

  useEffect(() => {
    function handleScroll() {
      setScrollingDown(window.pageYOffset > 32);
    }
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrollingDown]);

  return (
    <nav className={`mobileMenu ${scrollingDown ? 'scrolling' : ''}`} ref={mobileMenuRef}>
      <svg
        ref={circleRef}
        className="mobileMenu__circle"
        viewBox="0 0 42 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="21" cy="21" r="20.5" stroke="#FFFFFF" />
      </svg>
      <button className="nav__menu mobileMenu__menu" aria-controls="menu" onClick={showMobileMenu}>
        <div
          className="nav__menu__bar navBar__menu__bar-top mobileMenu__menu__bar"
          ref={topBarRef}
        />
        <div
          className="nav__menu__bar navBar__menu__bar-bttm mobileMenu__menu__bar"
          ref={bottomBarRef}
        />
      </button>

      {linksData.map((link, i) => (
        <a
          key={link.key}
          href={link.url}
          rel="noreferrer"
          className="mobileMenu__links"
          onClick={showMobileMenu}
        >
          {link.text}
        </a>
      ))}
      <a className="mobileMenu__logo" href="https://www.morganstanley.com/" target="_blanc">
        <img src={logo} alt="logo" />
      </a>
      <div className="mobileMenu__ctaLink">
        <a
          href="https://www.morganstanley.com/Themes/global-space-economy/?cid=mg-cap-cnncreat-12577"
          rel="noreferrer"
          target="_blank"
          className="mobileMenu__links ctaText"
          onClick={showMobileMenu}
        >
          Explore the new space economy
        </a>
        <img src={arrow} alt="arrow" />
      </div>
    </nav>
  );
}

export default MobileMenu;
